export default "__VITE_ASSET__BdDl19zB__"